import { formatDate } from '../../utils';

const transformUsersList = ({ results = [] }) =>
  results.map((user) => {
    const { id, firstName, lastName, email, role, status, createdAt } = user;
    return {
      userId: id,
      firstName,
      lastName,
      email,
      role,
      active: status === 'active',
      createdOn: formatDate(createdAt),
    };
  });

export default transformUsersList;
